import { useCallback, useContext, useEffect, useState } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { SkeletonLoader } from '../Common/SkeletonLoader';
import { useAdyen } from '@/hooks/useAdyen';
import { Email } from '../Common/Email';

import '@adyen/adyen-web/styles/adyen.css';
import '@/styles/adyen.css';
import { InputTaxComponent } from '../InputTaxComponent/InputTaxComponent';
import { shouldHideEmail } from '@/utils/conditionalRendering';
import { isEmailValid } from '@/utils/email';

export const AdyenCardForm = () => {
  const {
    customer,
    featureFlags,
    actions: { setIsFormValid },
  } = useContext(CheckoutContext);
  const { cardRef, isReady, isAdyenFieldsValid } = useAdyen();
  const [isZipCodeValid, setIsZipCodeValid] = useState(false);

  useEffect(() => {
    const isFormValid = isAdyenFieldsValid && isZipCodeValid && isEmailValid(customer?.email);
    setIsFormValid(isFormValid);
  }, [isAdyenFieldsValid, setIsFormValid, isZipCodeValid, customer?.email]);

  const handleTaxValidationChange = useCallback((isValid: boolean) => {
    setIsZipCodeValid(isValid);
  }, []);

  return (
    <div className="flex flex-col gap-4 w-full">
      {!shouldHideEmail(featureFlags) && <Email />}

      <div className="flex flex-col gap-4 w-full relative">
        {!isReady && (
          <div className="flex flex-col gap-4 w-full">
            <SkeletonLoader height="h-11" width="w-full" />
            <SkeletonLoader height="h-11" width="w-full" />
            <div className="flex gap-4 w-full">
              <SkeletonLoader height="h-11" width="w-1/2" />
              <SkeletonLoader height="h-11" width="w-1/2" />
            </div>
          </div>
        )}
        <div ref={cardRef} className={`w-full adyen-card-container ${!isReady ? 'hidden' : ''}`} />
      </div>
      <InputTaxComponent onValidate={handleTaxValidationChange} />
    </div>
  );
};
